import app from '../../forum/app';
import LinkButton from '../../common/components/LinkButton';
import DiscussionsSearchItem from './DiscussionsSearchItem';

/**
 * The `DiscussionsSearchSource` finds and displays discussion search results in
 * the search dropdown.
 */
export default class DiscussionsSearchSource {
  results = (() => new Map())();
  queryString = null;
  async search(query) {
    query = query.toLowerCase();
    this.results.set(query, []);
    this.setQueryString(query);
    const params = {
      filter: {
        q: this.queryString || query
      },
      page: {
        limit: this.limit()
      },
      include: this.includes().join(',')
    };
    return app.store.find('discussions', params).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    this.setQueryString(query);
    const results = (this.results.get(query) || []).map(discussion => {
      const mostRelevantPost = discussion.mostRelevantPost();
      return m(DiscussionsSearchItem, {
        query: query,
        discussion: discussion,
        mostRelevantPost: mostRelevantPost
      });
    });
    return [m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('core.lib.search_source.discussions.heading')), m("li", null, m(LinkButton, {
      icon: "fas fa-search",
      href: app.route('index', {
        q: this.queryString
      })
    }, app.translator.trans('core.lib.search_source.discussions.all_button', {
      query
    }))), ...results];
  }
  includes() {
    return ['mostRelevantPost'];
  }
  limit() {
    return 3;
  }
  queryMutators() {
    return [];
  }
  setQueryString(query) {
    this.queryString = query + ' ' + this.queryMutators().join(' ');
  }
}
flarum.reg.add('core', 'forum/components/DiscussionsSearchSource', DiscussionsSearchSource);